import React from 'react'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import AddIcon from '@mui/icons-material/Add'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import { QUOTE_URL } from 'signup/constants'
import { Flow } from '../types'

interface OtherOptionsProps {
  flow: Flow
  switchTo?: Flow[]
  onSwitch?: (flow: Flow) => void
}

// White pills on the warm off-white page, with a hairline border for contrast.
const PILL =
  'inline-flex items-center gap-2 rounded-pill border border-line-200 bg-white px-4 py-2 font-display text-13 font-semibold text-ink no-underline shadow-card transition hover:border-line-300 hover:shadow-lift'

const SWITCH_LABELS: Record<Flow, string> = {
  teacher: 'I want a teacher license',
  family: 'I want a family license',
  school: 'I want a school license',
}

function OtherOptions({ flow, switchTo, onSwitch }: OtherOptionsProps) {
  // Parents only get the sales contact; demo and quote are for teacher/school buyers.
  const salesOnly = flow === 'family'

  return (
    <div className='mt-7 text-center'>
      <p className='text-10 font-bold uppercase tracking-caps text-ink-500'>
        Other Options
      </p>
      <div className='mt-3 flex flex-wrap justify-center gap-3'>
        <a href='mailto:sales@xtramath.org' className={PILL}>
          <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
          Contact Sales
        </a>
        {(switchTo || [])
          .filter((option) => option !== flow)
          .map((option) => (
            <button
              key={option}
              type='button'
              onClick={() => onSwitch?.(option)}
              className={PILL}
            >
              <SwapHorizIcon sx={{ fontSize: 16 }} />
              {SWITCH_LABELS[option]}
            </button>
          ))}
        {!salesOnly && (
          <>
            <a
              href='https://meetings.hubspot.com/jackie-orcutt/demo'
              target='_blank'
              rel='noopener noreferrer'
              className={PILL}
            >
              <VideocamOutlinedIcon sx={{ fontSize: 16 }} />
              Request a demo
            </a>
            <a
              href={QUOTE_URL}
              target='_blank'
              rel='noopener noreferrer'
              className={PILL}
            >
              <AddIcon sx={{ fontSize: 16 }} />I need a quote
            </a>
          </>
        )}
      </div>
    </div>
  )
}

OtherOptions.defaultProps = { switchTo: undefined, onSwitch: undefined }

export default OtherOptions
